var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-bookmark",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.458,21l-0,0c-0.34,0 -0.616,-0.31 -0.616,-0.692l0,-15.923c0.001,-0.765 0.552,-1.384 1.232,-1.385l9.852,0c0.68,0.001 1.231,0.62 1.232,1.385l-0,15.923c-0,0.382 -0.276,0.692 -0.616,0.692c-0.11,-0 -0.213,-0.032 -0.302,-0.089l0.003,0.002l-5.244,-3.275l-5.242,3.275c-0.086,0.055 -0.189,0.087 -0.299,0.087l-0,0l-0,0Zm5.51,-4.846l0.065,-0c0.11,-0 0.179,0.032 0.269,0.089l-0.004,-0.002l4.458,2.89l-0,-14.746l-9.528,-0l-0,14.746l4.472,-2.89c0.087,-0.055 0.158,-0.087 0.268,-0.087Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRBookmark);
export default __webpack_public_path__ + "static/media/iconR-bookmark.cbf217db15431d50c5594231ee8e1642.svg";
export { ForwardRef as ReactComponent };